export default __webpack_public_path__ + "static/media/trr-food-handheld-eggandcheese.9e0807f7.png";